jQuery(document).ready(function ($) {
  // Fix browser auto scroll jump after AJAX content update
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  /**
   * Unified Factory to handle WordPress AJAX Listings
   */
  window.createAjaxHandler = function (config) {
    let currentPage = config.initialPage || 1;
    let searchTerm = '';
    let currentCategory = config.initialCategory || 'all';
    let isLoading = false;

    // Cache jQuery elements safely (only if selectors are provided)
    const $results = config.selectors.results ? $(config.selectors.results) : null;
    const $loading = config.selectors.loading ? $(config.selectors.loading) : null;
    const $searchInput = config.selectors.searchInput ? $(config.selectors.searchInput) : null;
    const $searchBtn = config.selectors.searchBtn ? $(config.selectors.searchBtn) : null;
    const $filterBtns = config.selectors.filterBtns ? $(config.selectors.filterBtns) : null;

    function loadData(page = 1, search = searchTerm, category = currentCategory) {
      if (isLoading) return;
      isLoading = true;

      if ($loading) {
        $loading.show().addClass('is-loading');
        $loading.addClass('is-loading'); // Kept duplicate class add per your original code
      }

      // Build data payload dynamically based on what the endpoint expects
      const ajaxData = {
        action: config.ajaxAction,
        nonce: config.getNonce(),
      };

      if (config.hasPage !== false) ajaxData.page = page;
      if (config.hasSearch !== false) ajaxData.search = search;
      if (config.hasCategory) ajaxData.category = category;

      $.ajax({
        url: window.ccn.ajax_url,
        type: 'POST',
        data: ajaxData,
        success: function (response) {
          if ($results) {
            $results.html(response);
          }
          currentPage = $.isNumeric(page) ? parseInt(page, 10) : page;
          searchTerm = search;
          currentCategory = category;
          // Wait until new DOM is rendered
          requestAnimationFrame(() => {
            // Reinitialize GSAP animations
            if (typeof window.initScrollAnimations === 'function') {
              window.initScrollAnimations();
            }
            // Refresh all ScrollTriggers
            if (typeof ScrollTrigger !== 'undefined') {
              ScrollTrigger.refresh();
            }
          });
          smoothScrollAfterAjax();
          if (!config.useDelegatedPagination) {
            bindPaginationStatic();
          }
        },
        error: function () {
          if ($results) {
            $results.html(`<p class="error">${config.errorMsg || 'Failed to load data. Please try again.'}</p>`);
          }
        },
        complete: function () {
          if ($loading) $loading.hide().removeClass('is-loading');
          if ($results) $results.removeClass('is-loading');
          isLoading = false;
        },
      });
    }

    function scrollToContainer() {
      if (!config.selectors.scrollTarget) return;
      const $target = $(config.selectors.scrollTarget);
      if ($target.length) {
        const offset = config.scrollOffset || 150;
        const speed = config.scrollSpeed || 500;
        const targetTop = $target.offset().top - offset;
        $('html, body').stop(true, true).animate({ scrollTop: targetTop }, speed);
      }
    }

    // =====================================
    // Universal AJAX smooth scroll fix
    // Works for all filters + pagination
    // =====================================

    function smoothScrollAfterAjax() {
      setTimeout(function () {
        if (!config.selectors.scrollTarget) return;

        const $target = $(config.selectors.scrollTarget);

        if ($target.length) {
          const offset = config.scrollOffset || 150;

          const targetTop = $target.offset().top - offset;

          window.scrollTo({
            top: targetTop,
            behavior: 'smooth',
          });
        }
      }, 100);
    }

    // Helper function to parse page number out of pagination clicked elements
    function parsePageNum($link) {
      const href = $link.attr('href') || '';
      const text = $link.text().trim().toLowerCase();
      let match;

      if ((match = href.match(/[?&]paged=(\d+)/i)) || (match = href.match(/paged=(\d+)/))) {
        return parseInt(match[1], 10);
      } else if ((match = href.match(/page\/(\d+)/i)) || (match = href.match(/\/page\/(\d+)\/?/i))) {
        return parseInt(match[1], 10);
      } else if ((match = href.match(/\/(\d+)[\/]?$/))) {
        return parseInt(match[1], 10);
      } else if ($.isNumeric(text)) {
        return parseInt(text, 10);
      } else if (
        text === '1' ||
        $link.hasClass('current') ||
        href.endsWith('/') ||
        (!href.includes('paged') && !href.includes('page/') && href !== '')
      ) {
        return 1;
      } else if ($link.hasClass('prev') || text.includes('previous') || text.includes('«')) {
        return currentPage - 1;
      } else if ($link.hasClass('next') || text.includes('next') || text.includes('»')) {
        return currentPage + 1;
      }
      return 1;
    }

    // Static pagination wrapper (for files using bindPagination)
    function bindPaginationStatic() {
      if (!config.selectors.paginationLinks) return;
      $(config.selectors.paginationLinks)
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
          const pageNum = parsePageNum($(this));
          if (pageNum > 0 && pageNum !== currentPage) {
            loadData(pageNum, searchTerm, currentCategory);
          }
        });
    }

    // --- Core Initialization Event Listeners ---

    // 1. Static Pagination Setup
    if (!config.useDelegatedPagination) {
      bindPaginationStatic();
    }
    // 2. Dynamic/Delegated Pagination Setup (Initiatives & Projects)
    else if (config.selectors.paginationContainer && config.selectors.paginationLinks) {
      $(document).on('click', `${config.selectors.paginationContainer} a`, function (e) {
        e.preventDefault();
        const pageNum = parsePageNum($(this));
        if (pageNum > 0) {
          // Initiative pagination forced pageNum reset unless calculated
          const actualPage = config.forcePaginationResetToOne ? 1 : pageNum;
          loadData(actualPage, searchTerm, currentCategory);
        }
      });
    }

    // 3. Search Setup
    if ($searchBtn && $searchInput) {
      $searchBtn.on('click', function () {
        searchTerm = $searchInput.val().trim();
        loadData(1, searchTerm, currentCategory);
      });

      $searchInput.on('keypress', function (e) {
        if (e.which === 13) {
          searchTerm = $(this).val().trim();
          loadData(1, searchTerm, currentCategory);
        }
      });
    }

    // 4. Category Filters Setup
    if ($filterBtns) {
      // Handles both dynamic and static category selectors depending on configuration
      const eventTarget = config.useDelegatedFilters ? document : $filterBtns;
      const eventSelector = config.useDelegatedFilters ? config.selectors.filterBtns : undefined;

      $(eventTarget).on('click', eventSelector, function () {
        if ($(this).hasClass('active') || isLoading) return;

        $(config.selectors.filterBtns).removeClass('active');
        $(this).addClass('active');

        let catValue = $(this).data('cat');
        // Team uses strict numerical parsed IDs
        if (config.isTeamModule) catValue = parseInt(catValue, 10);

        currentCategory = catValue;

        // Reset search bar if changing category tags (matches initiative/projects logic)
        if (config.resetSearchOnCategoryChange && $searchInput) {
          searchTerm = '';
          $searchInput.val('');
        }

        loadData(1, searchTerm, currentCategory);
      });
    }
  };

  // ==========================================
  // INITIALIZE INSTANCES (Replacing your old scripts)
  // ==========================================

  // 1. Featured News
  const featuredInitialCat = $('#featured_section').data('current-category') || 'all';

  window.createAjaxHandler({
    ajaxAction: 'load_featured_news',
    getNonce: () => window.ccn.featured_nonce,
    hasCategory: true,
    initialCategory: featuredInitialCat,
    resetSearchOnCategoryChange: false,
    useDelegatedPagination: true,
    useDelegatedFilters: false,
    scrollOffset: 120,
    scrollSpeed: 500,
    selectors: {
      results: '#featured-news-results',
      loading: '#featured-news-loading',
      searchInput: '#featured-news-search',
      searchBtn: '#featured-news-search-btn',
      scrollTarget: '#featured-news-listing',
      paginationContainer: '.featured-news-pagination',
      paginationLinks: '.featured-news-pagination a',
    },
  });

  // 2. Initiatives
  window.createAjaxHandler({
    ajaxAction: 'load_initiatives',
    getNonce: () => window.ccn.initiatives_nonce,
    hasCategory: true,
    resetSearchOnCategoryChange: true,
    useDelegatedPagination: true,
    scrollOffset: 150,
    scrollSpeed: 500,
    selectors: {
      results: '#initiative-results',
      loading: '#initiative-loading',
      searchInput: '#initiative-search', // Preserved specific capital uppercase 'I'
      searchBtn: '#initiative-search-btn',
      filterBtns: '#initiative-filter-tabs .filter-tabs__btn',
      scrollTarget: '#initiative-results',
      paginationContainer: '.initiative-pagination',
      paginationLinks: '.initiative-pagination a',
    },
  });

  // 2. vacancy
  window.createAjaxHandler({
    ajaxAction: 'load_vacancies',
    getNonce: () => window.ccn.vacancies_nonce,
    scrollOffset: 150,
    scrollSpeed: 500,
    selectors: {
      results: '#vacancy-results',
      loading: '#vacancy-loading',
      searchInput: '#vacancy-search',
      searchBtn: '#vacancy-search-btn',
      scrollTarget: '#vacancy-listing',
    },
  });

  // 3. Partners
  window.createAjaxHandler({
    ajaxAction: 'load_partners',
    getNonce: () => window.ccn.partners_nonce || '<?php echo wp_create_nonce("partners_nonce"); ?>', // Preserved inline PHP snippet safety
    scrollOffset: 150,
    scrollSpeed: 500,
    selectors: {
      results: '#partners-results',
      loading: '#partners-loading',
      searchInput: '#partners-search',
      searchBtn: '#partners-search-btn',
      scrollTarget: '#partners-listing',
      paginationLinks: '#partners_pagination a',
    },
  });

  // 4. Projects
  const $projectActiveBtn = $('.filter-tabs__btn.active').first();
  const projectInitialCat = $projectActiveBtn.length ? $projectActiveBtn.data('cat') : 'all';

  window.createAjaxHandler({
    ajaxAction: 'load_projects',
    getNonce: () => window.ccn.projects_nonce,
    hasCategory: true, // still send category with search
    initialCategory: projectInitialCat, // start with current category
    resetSearchOnCategoryChange: false,
    useDelegatedPagination: true,
    useDelegatedFilters: false, // ← important: no click on filter tabs
    scrollOffset: 150,
    scrollSpeed: 500,
    selectors: {
      results: '#project-results',
      loading: '#project-loading',
      searchInput: '#project-search',
      searchBtn: '#project-search-btn',
      // filterBtns intentionally removed so tabs stay normal links
      scrollTarget: '#project-listing-container',
      paginationContainer: '.project-pagination',
      paginationLinks: '.project-pagination a',
    },
  });

  // 4. Events
  const $eventActiveBtn = $('.filter-tabs__btn.active').first();
  const eventInitialCat = $eventActiveBtn.length ? $eventActiveBtn.data('cat') : 'all';

  window.createAjaxHandler({
    ajaxAction: 'load_events',
    getNonce: () => window.ccn.events_nonce,
    hasCategory: true, // send category with search
    initialCategory: eventInitialCat, // start with current category
    resetSearchOnCategoryChange: false,
    useDelegatedPagination: true,
    useDelegatedFilters: false, // category tabs stay normal links
    scrollOffset: 150,
    scrollSpeed: 500,
    selectors: {
      results: '#event-results',
      loading: '#event-loading',
      searchInput: '#event-search',
      searchBtn: '#event-search-btn',
      // filterBtns intentionally removed
      scrollTarget: '#event-listing-container',
      paginationContainer: '.story-pagination', // matches the class in event-loop.php
      paginationLinks: '.story-pagination a',
    },
  });

  // 5. Stories
  window.createAjaxHandler({
    ajaxAction: 'ajax_story_filter',
    getNonce: () => window.ccn.story_nonce,
    scrollOffset: 150,
    scrollSpeed: 500,
    selectors: {
      results: '#story-results',
      loading: '#story-loading',
      searchInput: '#story-search',
      searchBtn: '#story-search-btn',
      scrollTarget: '#story-listing',
      paginationLinks: '.story-pagination a',
    },
  });

  // 6. Team
  const $teamActiveBtn = $('#team-filter-tabs .filter-tabs__btn').filter('.active').first();
  const teamInitialCat = $teamActiveBtn.length ? parseInt($teamActiveBtn.data('cat'), 10) : 0;

  window.createAjaxHandler({
    ajaxAction: 'load_team',
    getNonce: () => window.ccn.team_nonce,
    hasCategory: true,
    hasPage: false,
    hasSearch: false,
    isTeamModule: true,
    initialCategory: teamInitialCat,
    scrollOffset: 150,
    scrollSpeed: 600,
    selectors: {
      results: '#team-results',
      loading: '#team-loading',
      filterBtns: '#team-filter-tabs .filter-tabs__btn',
      scrollTarget: '#team-listing',
    },
  });
});
